var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hasError
    ? _c(
        "ul",
        {
          staticClass: "grid sm:grid-cols-2 gap-3",
          attrs: { "data-testid": "exterior-results" },
        },
        [
          _c(
            "li",
            {
              staticClass:
                "flex justify-between sm:flex-col bg-white px-3 py-4",
            },
            [
              _c(
                "h4",
                { staticClass: "sm:text-md flex items-center leading-tight" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "link underline",
                      attrs: { href: "/paint/enamel-paint" },
                    },
                    [_vm._v("Enamel Paint")]
                  ),
                  _vm._v(" "),
                  _c("ButtonInfo", {
                    staticClass: "ml-2",
                    attrs: {
                      heading: "",
                      body: "High performing & long lasting paint for all exterior projects (excluding decking)",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sm:text-md font-semibold" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("formatVolume")(_vm.quantities.wallPaint)) +
                    "\n    "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.isNewJob
            ? _c(
                "li",
                {
                  staticClass:
                    "flex justify-between sm:flex-col bg-white px-3 py-4",
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "sm:text-md flex items-center leading-tight",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "link underline",
                          attrs: {
                            href: "/supplementary/speciality-undercoat",
                          },
                        },
                        [_vm._v("Speciality Undercoat")]
                      ),
                      _vm._v(" "),
                      _c("ButtonInfo", {
                        staticClass: "ml-2",
                        attrs: {
                          heading: "",
                          body: "An exterior undercoat perfect for priming all unpainted substrates",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "sm:text-md font-semibold" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm._f("formatVolume")(_vm.quantities.primer)) +
                        "\n    "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }